import ButtonBase from '@mui/material/ButtonBase'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { setMealNotes, UserMealPlanDataSelector } from '../../../app/mealPlan/mealPlan.slice';
import { useAppSelector } from '../../../app/store/hooks';
import { DeleteIcon } from '../../../iconRef/mealPLanIcons';
import Loader from '../../../pages/mealPlan/Loader';
import CheckIcon from '@mui/icons-material/Check';

import { MealNote } from '../mealPlan.types';
import styles from './NotesCard.module.css'
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { DELETE_MEAL_NOTE, UPDATE_NOTE_STATUS } from '../../../app/graphql/mutations';
import { Grid2 } from '@mui/material';
import { NOTE_STATUS } from '../constants';


const MealNoteCard = ({ note, refetchNotes }: { note: MealNote, refetchNotes: () => Promise<void> }) => {
    const userMealPlanData = useAppSelector(UserMealPlanDataSelector);
    const meal_plan_id = userMealPlanData?.meal_plan_id;
    const noteContent = note?.content;
    const [isChecked, setIsChecked] = useState(note.status === NOTE_STATUS.COMPLETED);
    const [translateX, setTranslateX] = useState(0);
    const [startX, setStartX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [deleteNote, { loading: deletingNote }] = useMutation(DELETE_MEAL_NOTE)
    const [updateNoteStatus, { loading: updatingNoteStatus }] = useMutation(UPDATE_NOTE_STATUS)

    const handleNoteDelete = async (noteId: string) => {
        if (noteId) {
            await deleteNote({
                variables: {
                    note_id: noteId
                }
            })
            await refetchNotes()
        }
    }

    const handleNoteStatusToggle = async () => {
        const noteId = note.id;
        const updatedStatus = isChecked ? NOTE_STATUS.PENDING : NOTE_STATUS.COMPLETED;
        const currentIsChecked  = isChecked;
        try{
            if (noteId) {
                setIsChecked(!isChecked); 
                await updateNoteStatus({
                    variables: {
                        id: noteId,
                        status: updatedStatus,
                    },
                });
                await refetchNotes();
            }
        }
        catch(e){
            setIsChecked(currentIsChecked); 
            console.error("Error occured while updating note", e)
        }
    };


    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        const touch = e.touches[0];
        setStartX(touch.clientX);
        setIsDragging(true);
    };

    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        if (!isDragging) return;

        const touch = e.touches[0];
        const currentX = touch.clientX;
        const deltaX = currentX - startX;

        let newTranslateX = translateX + deltaX;
        if (newTranslateX > 0) {
            newTranslateX = 0;
        } else if (newTranslateX < -100) {
            newTranslateX = -100;
        }

        setTranslateX(newTranslateX);
        setStartX(currentX);
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
        if (translateX > -100) {
            setTranslateX(0);
        }
    };

    useEffect(() => {
      setIsChecked(note.status === NOTE_STATUS.COMPLETED)
    }, [note])
    

    return <Grid2 className={styles.meal_card_wrapper}>
        <Grid2 onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
            onTouchStart={handleTouchStart}
            style={{
                zIndex: 1,
                display: "flex",
                transform: `translateX(${translateX}px)`,
                transition: isDragging ? 'none' : 'transform 0.3s ease',
                width: "100%"
            }}>
            <Grid2 className={styles.recipe_card} onClick={handleNoteStatusToggle}>
                {noteContent?.image ? <Grid2 className={styles.recipe_image}>
                    <img src={noteContent.image} />
                </Grid2> : null}
                <Grid2 className={styles.recipe_details}>
                    <Typography className={styles.recipe_title} variant='ingredientText1Outfit'>{noteContent.name.split('\n').map((line, index) => (
                        <>
                            {line}
                            <br />
                        </>
                    ))}
                    </Typography>

                    {/* <Grid className={styles.recipe_extra_info}>
                        <Typography className={styles.recipe_kcal} component="p" variant="caloriesText">{noteContent?.nutritionalInfo?.calories} Kcal</Typography>
                    </Grid> */}
                </Grid2>
                <Grid2 style={{ backgroundColor: isChecked ? '#4caf50' : '#fff' }} className={styles.check_icon}>
                    {isChecked? <CheckIcon fontSize='small' />: null}
                </Grid2>
            </Grid2>
        </Grid2>
        <ButtonBase
            className={styles.delete_btn}
            onClick={() => handleNoteDelete(note?.id)}
        >
            <DeleteIcon />
            <Typography variant='caption4LightOutfit'>Delete</Typography>
        </ButtonBase>
        <Loader loading={deletingNote} />
    </Grid2>

}

export default MealNoteCard

// 
